import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function TaxpayerInformation({ data }) {

  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Account Name</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="150">
              Last Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.last_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="150">
              First Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.first_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="150">
              Middle Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.middle_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="150">
              Suffix
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.suffix') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Designation/Position/Title
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.designation') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Gender
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.gender') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Civil Status
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.civil_status') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Date of Birth
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.birth_date') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Email
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.email_address') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Mobile No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.mobile_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Telephone No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.telephone_number') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Residential Address</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Region
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.region_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Province
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.province_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              City/Municipality
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.municipality_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              ZIP Code
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Barangay
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.barangay_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Street
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.street') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Subdivision
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.subdivision') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Block No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.block_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Lot No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.lot_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Name of Building
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.building_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              House/Bldg. No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.house_bldg_no') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              For Corporation
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.for_corporation') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Government IDs</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              TIN
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.tin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Pag-IBIG ID No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.pagibig_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Philhealth ID No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.philhealth_no') || '-'}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

TaxpayerInformation.defaultProps = {
  data: {},
}

TaxpayerInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default TaxpayerInformation;
